export const getAllPropInfos = (contractInfo) => contractInfo.propInfos.concat(contractInfo.superSmartContract === undefined ? [] : getAllPropInfos(contractInfo.superSmartContract));

//# sourceMappingURL=getAllPropInfos.js.map
